<res-base-modal [modalTitle]="modalTitle" [modalAutomationId]="modalAutomationId"
    [verifyRequiredValidator]="verifyRequiredValidator" [primaryButtonLabel]="primaryButtonLabel"
    (primaryButtonActionEmt)="OK()" (closeButtonActionEmt)="closeModal()" [secondaryButtonLabel]="secondaryButtonLabel"
    [isPrimaryBtnEnabled]="isPrimaryButtonEnabled()" [(isBusy)]="isBusy" [modalHelpIndex]="modalHelpIndex"
    [(isBusyMessage)]="isBusyMessage" [modalClass]="modalClass">
    <res-name-description [isNameDisabled]="isNameDisabled" [isDescriptionDisabled]="isDescriptionDisabled"
        [automationId]="modalAutomationId" [validateName]="true" [validateNameRequest]="validateNameRequest">
    </res-name-description>
    <div class="modal-row">
        <div class="modal-row-column-auto group-label">
            <label for="pattern" requiredAsterisk [isRequired]="!isPatternDisabled">Pattern:
            </label>
        </div>
        <div class="modal-row-column-max description">
            <textarea id="description" class="patternTextArea" [(ngModel)]="pattern"
                (focusout)="onPatternFocusLost($event)" [attr.data-automation-id]="'pattern-template-pattern-input'"
                [disabled]="isPatternDisabled" name="description" (ngModelChange)="onPatternChanged()" maxlength="4000"
                [(resScrollablePopover)]="showPatternPopover" popoverPlacement="bottom" [popoverOffsetLeft]="25"
                popoverErrorMessage="The regular expression syntax is incorrect." popoverType="error"
                [isSingleLine]="true" (click)="onPatternFocus()"
                [popoverAutomationId]="modalAutomationId  + '-pattern-syntax-error-label'"></textarea>
        </div>
    </div>
    <div class="modal-row allCheckBoxes">
        <div class="modal-row-column-auto group-label">
            <label for="enable" [class.disabled]="false">Enable:</label>
        </div>
        <div class="modal-row-column-auto description">
            <res-custom-checkbox automationId="pattern-template-enable-checkbox" [(ngModel)]="enable"
                (ngModelChange)="toggleEnabled()"></res-custom-checkbox>
        </div>
    </div>
    <div class="modal-row allCheckBoxes">
        <div class="modal-row-column-auto group-label">
            <label for="storeValue" [class.disabled]="false">Store Value:</label>
        </div>
        <div class="modal-row-column-auto description">
            <res-custom-checkbox automationId="pattern-template-store-value-checkbox" [(ngModel)]="storeValue"
                (ngModelChange)="toggleStoreValue()"></res-custom-checkbox>
        </div>
    </div>
</res-base-modal>